import { ListNotarials } from "../../../../fragments/admin/services/notarial/ListNotarial"

export const Notarials = () => {

    return  <main>
    <ListNotarials/>
    </main>
}